import script from "./GridReasonsReportsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridReasonsReportsComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridReasonsReportsComponent.vue?vue&type=style&index=0&id=5adc67b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adc67b2"]])

export default __exports__